import { render, staticRenderFns } from "./BtcTransactionModal.vue?vue&type=template&id=2503b68d&scoped=true&"
import script from "./BtcTransactionModal.vue?vue&type=script&lang=ts&"
export * from "./BtcTransactionModal.vue?vue&type=script&lang=ts&"
import style0 from "./BtcTransactionModal.vue?vue&type=style&index=0&id=2503b68d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503b68d",
  null
  
)

export default component.exports